module.exports = __webpack_public_path__ + "static/media/pn_billboard_banner_default_375.b6e42c19.png";